// extracted by mini-css-extract-plugin
export var contentWrapper = "index-module--contentWrapper--rnzD7";
export var leftWrapper = "index-module--leftWrapper--q24qY";
export var rightWrapper = "index-module--rightWrapper--nlbPi";